/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { useState } from "react";
import { readStorage, writeStorage } from "./storage";

/** A choice remembered in this browser under its key; the fallback until one is made. */
export function useStoredChoice<T extends string>(
  key: string,
  fallback: T,
  allowed: readonly T[],
): [T, (next: T) => void] {
  const [choice, setChoice] = useState<T>(() => {
    const stored = readStorage(key);
    return allowed.includes(stored as T) ? (stored as T) : fallback;
  });
  const choose = (next: T) => {
    setChoice(next);
    writeStorage(key, next);
  };
  return [choice, choose];
}
